export const ANALYTICS_EVENTS = {
    ADMIN: {
        ASSET_TYPE_ADDED: 'Added asset type(s)',
        ASSET_TYPE_REMOVED: 'Removed asset type(s)',
        DELETE_WORKFLOW: 'Deleted workflow',
        DISABLE_WORKFLOW: 'Disable workflow',
        ENABLE_WORKFLOW: 'Enable workflow',
        NEW_WORKFLOW: 'Create workflow',
        RENAME_WORKFLOW: 'Rename workflow',
        TASK_ADDED: 'New default task(s)',
        TASK_COUNT: 'Task count',
        TASK_REMOVED: 'Removed default task(s)',
        TASK_UPDATED: 'Updated default task(s)',
        RENAME_STATUS: 'Status renamed',
        REPORT_TEMPLATE_UPLOAD: 'Report - Template created',
        REPORT_TEMPLATE_UPDATE: 'Report - Template updated',
        REPORT_TEMPLATE_DOWNLOAD: 'Report - Template downloaded',
        REPORT_TEMPLATE_DELETION: 'Report - Template deleted',
        STAGE_ADDED: 'Stage(s) added to a workflow',
        STAGE_DISABLED: 'Stage(s) disabled',
        STAGE_UPDATED: 'Stage(s) updated',
        STAGE_REORDERED: 'Stage(s) reordered',
        STAGE_REMOVED: 'Removed stage(s)',
        STAGE_TASK_ADDED: 'New default task(s) on stage',
        STAGE_TASK_REMOVED: 'Removed default task(s) on stage',
        STAGE_TASK_UPDATED: 'Updated default task(s) on stage',
        EVALUATE_ADD_USER: 'Evaluate - Add Advanced user',
        EVALUATE_REMOVE_USER: 'Evaluate - Remove Advanced user'
    },
    AGREEMENT: {
        COPY_URL: 'Copy agreement URL'
    },
    AMENDMENT: {
        COPY_URL: 'Copy amendment URL'
    },
    OBLIGATION: {
        COPY_URL: 'Copy obligation URL'
    },
    ALLIANCE: {
        COPY_URL: 'Copy alliance URL'
    },
    ALL_LEADS_LIST_MENU: {
        BUTTON_ALL_LEADS: 'Click all leads menu',
        SEARCH_BAR: 'Search a presaved list'
    },
    ACCOUNT_MENU: {
        OPENED: 'Click on Profile',
        SETTINGS: 'Click on My Profile',
        PLATFORM_SETTINGS: 'Click on Administration'
    },
    BRIEF_ACCESS_CONTROL: {
        ADD_MEMBERS: 'Give access to user or group on a brief',
        MAIN_OWNER_CHANGE: 'Make a user Main Owner',
        MAKE_PRIVATE: 'Make a brief private',
        MAKE_PUBLIC: 'Make a brief public',
        REMOVE_AUTHORIZED_GROUP: "Remove a group from a brief's ACL",
        REMOVE_AUTHORIZED_USER: "Remove an user from a brief's ACL",
        REMOVE_OWNER: "Remove an owner from a brief's ACL",
        UPDATE_MEMBER_ACCESS: "Update a user's access"
    },
    BRIEF_CARD: {
        CLICK: 'Brief card click',
        SUBMIT_BTN: 'Brief card submit button'
    },
    BRIEF_CREATION: {
        CREATE_BUTTON: 'Click on Create Brief button',
        SUCCESSFUL: 'Successfully creating a new brief',
        USE_COLOR: 'Use “color” marker list value'
    },
    BRIEF_NOTES: {
        CANCEL: 'Cancel brief note edition',
        EDIT: 'Edit brief note',
        SAVE: 'Save brief note'
    },
    BRIEF_OVERVIEW: {
        CANCEL_TITLE: 'Cancel brief title dialog',
        DELETE: 'Delete a brief',
        EDIT_TITLE: 'Save brief title',
        DESCRIPTION: 'Click on "Description" tab (brief overview)',
        EXCEL_IMPORT: 'Click on Excel import button',
        ADD_MEMBERS: 'Add member',
        ATTACHMENTS: 'Click on "Attachments" tab (brief overview)',
        LEADS: 'Click on "Leads" tab (brief overview)',
        LEAD_PROGRESS_BAR: 'Click on lead progress bar (brief overview)',
        MEMBERS_OPENED: 'Open brief members list',
        MENU: 'Click on the "three dots" menu (brief overview)',
        TITLE: 'Click on brief title'
    },
    BRIEF_ATTACHMENTS: {
        DELETE: 'Brief attachments: Delete file',
        DOWNLOAD: 'Brief attachments : Download file',
        EDIT: 'Brief attachments: Edit file',
        PREVIEW: 'Brief attachments : Preview file',
        UPLOAD: 'Brief attachments: Upload file(s)'
    },
    CAMPAIGN: {
        CANCEL_CONNECTION: 'Cancel connection',
        CLICK_BANNER: 'Click on “find out more” in the banner',
        CLICK_CARD: 'Click on campaign card',
        CREATE_CAMPAIGN: 'Click on "create a campaign"',
        EDIT_CAMPAIGN: 'Edit campaign',
        REQUEST_CONNECTION: 'Request connection',
        UPDATE_STATUS: 'Update status',
        VIEW_ALL: 'Click on "view all"'
    },
    COMPANY_DETAILS: {
        OPEN_AGREEMENT_TAB: 'Company page - Open agreements list',
        OPEN_AGREEMENT: 'Company page - Open Agreement',
        CHANGE_AGREEMENT_STATUS: 'Company page - Change agreement status',
        CREATE_AGREEMENT: 'Company page - Create agreement',
        DELETE_COMPANY: 'Delete a company',
        EDIT_COMPANY: 'Edit company',
        OPEN_COMPANY_PROFILE_FROM_DNA: 'Access to a company profile from D&A',
        OPEN_DNA_PROFILE_FROM_COMPANY: 'Click to open the D&A profile from a company',
        CREATE_COMPANY_MANUALLY: 'Create Company - Manually',
        OPEN_EXTERNAL_LINK: 'Open linked company in DnA',
        OPEN_LEAD_FROM_COMPANY: 'Click on a lead listed in a company profile',
        UPDATE_COMPANY_PROFILE_FROM_COMPANY: 'Update the company from the company profile'
    },
    CONTACT_CREATION: {
        ADD_JOB: 'Click on "Add job"',
        ADD_EMAIL: 'Click on "Add email"',
        ADD_PHONE: 'Click on "Add phone"',
        ADD_URL: 'Click on "Add url"',
        CANCEL_BUTTON: 'Click on Cancel Contact Creation/Edition button',
        CREATE_BUTTON: 'Click on Create button to create the contact',
        UPDATE_BUTTON: 'Click on Update Contact button',
        INTERNAL_CONTACT_CREATED: 'Internal Contact - Create Successfully',
        INTERNAL_CONTACT_UPDATED: 'Internal Contact - Edit Successfully'
    },
    CONTACT_COMPANY_TAB: {
        ADD_EXISTING: 'Click on "Add Contact" button and on an existing contact on company\'s page',
        ADD_NEW: 'Click on "Add Contact" button and on "Add" button on company\'s page',
        CLICK_ON_CONTACT: "Click on a contact's name on company's page"
    },
    CONTACT_LEAD_TAB: {
        ADD_EXISTING: 'Click on "Add Contact" button and on an existing contact on lead\'s page',
        ADD_NEW: 'Click on "Add Contact" button and on "Add" button on lead\'s page',
        CHECK_KEY_CONTACT: 'Check/uncheck a contact as "key contact"',
        CLICK_ON_CONTACT: "Click on a contact's name on lead's page",
        REMOVE_ROLE: 'Remove the role of a contact',
        SELECT_ROLE: 'Select a role for a contact'
    },
    CONTACT_LIST: {
        APPLY_FILTER: 'Click on apply Contact filter button',
        CLICK_CREATE: 'Click on Create Contact button',
        CLICK_ON_CONTACT: "Click on a contact's name on contact list",
        CLICK_ON_MENU: 'Click on contact menu',
        EXPORT: 'Click on Export contact list button',
        TOGGLE_FILTER: 'Click on Contact filter button'
    },
    CONTACT_PROFILE: {
        BIG_DISPLAY: 'The page is viewed on big display',
        CLICK_ON_COMPANY: 'Click on company name',
        CLICK_ON_EMAIL: 'Click on email address',
        CLICK_ON_LEAD: "Click on lead's name",
        CLICK_ON_AGREEMENT: "Click on agreement's name",
        CLICK_ON_ALLIANCE: "Click on alliance's name",
        COPY_EMAIL: 'Click on copy email address',
        DELETE_BUTTON: 'Click on Delete Contact button',
        INTERNAL_CONTACT_DELETED: 'Internal Contact - Delete Successfully',
        EDIT_BUTTON: 'Click on Edit Contact button',
        EDIT_NOTES: 'Notes edited directly from contact page',
        SMALL_DISPLAY: 'The page is viewed on small display'
    },
    DASHBOARDS: {
        CLICK_ON_SHOW_IN_DASHBOARD: 'Click on show in dashboard on homepage card',
        CLICK_ON_MENU_ITEM: 'Click on Dashboard menu item',
        FILTER: 'Click on filter button',
        LEAD_DISCOVERY_FILTER: 'Click on chart to filter - opportunity discovery',
        DISTRIBUTION_DETAILS_FILTER: 'Click on chart to filter - Distribution details',
        MATRIX_FILTER: 'Click on chart to filter - {y} vs {x}',
        LEAD_PIPELINE_FILTER: 'Click on chart to filter - Opportunity pipeline - Qualification',
        DEAL_PIPELINE_FILTER: 'Click on chart to filter - Opportunity pipeline - Workflow stage',
        CLICK_ON_EXPORT: 'Click on export data button',
        CLICK_ON_VIEW_RESULTS: 'Click on view results button'
    },
    DIRECTORY: {
        OPEN_PANEL: 'Data - Open Databases Panel',
        COMPANY: {
            SHOW_MATCHES: 'Data - Show company suggested profiles',
            LINK: 'Data - Mark favorite a company profile',
            UNLINK: 'Data - Unmark favorite a company profile',
            REJECT: 'Data - Hide a company profile',
            SHOW_REJECTED: 'Data - Show company rejected profiles',
            UN_REJECT: 'Data - Unhide a company profile',
            VIEW_PROFILE: 'Data - View company profile'
        },
        ASSET: {
            SHOW_MATCHES: 'Data - Show asset suggested profiles',
            LINK: 'Data - Mark favorite an asset profile',
            UNLINK: 'Data - Unmark favorite an asset profile',
            REJECT: 'Data - Hide an asset profile',
            SHOW_REJECTED: 'Data - Show asset rejected profiles',
            UN_REJECT: 'Data - Unhide an asset profile',
            VIEW_PROFILE: 'Data - View asset profile',
            VIEW_COMPANY_PROFILE: 'Data - View asset company profile'
        }
    },
    EMAIL_IMPORT: {
        DELETED: 'Lead emails: delete email',
        MARK_AS_IMPORTANT: 'Lead emails: marked as important',
        NOTES_ADDED: 'Lead emails: notes added',
        PARSED: 'Lead emails: Successfully parsed',
        PREVIEW_ATTACH: 'Lead emails: preview attachment',
        SELECTED_ALL_ATTACHMENTS: "Lead emails: selected all email's attachments",
        SELECTED_NONE_ATTACHMENTS: "Lead emails: selected none email's attachments",
        SELECTED_SOME_ATTACHMENTS: "Lead emails: selected some email's attachments",
        UPLOAD: 'Lead emails: Successfully imported'
    },
    EVALUATE: {
        COMPANY: {
            SHOW_MATCHES: 'Evaluate - Show company suggested profiles',
            LINK: 'Evaluate - Mark favorite a company profile',
            UNLINK: 'Evaluate - Unmark favorite a company profile',
            REJECT: 'Evaluate - Hide a company profile',
            SHOW_REJECTED: 'Evaluate - Show company rejected profiles',
            UN_REJECT: 'Evaluate - Unhide a company profile',
            VIEW_PROFILE: 'Evaluate - View company profile',
            VIEW_SOURCE: 'Evaluate - View company profile source',
            CTA: 'Evaluate - Click on company profile CTA'
        },
        ASSET: {
            SHOW_MATCHES: 'Evaluate - Show asset suggested profiles',
            LINK: 'Evaluate - Mark favorite an asset profile',
            UNLINK: 'Evaluate - Unmark favorite an asset profile',
            REJECT: 'Evaluate - Hide an asset profile',
            SHOW_REJECTED: 'Evaluate - Show asset rejected profiles',
            UN_REJECT: 'Evaluate - Unhide an asset profile',
            VIEW_PROFILE: 'Evaluate - View asset profile',
            VIEW_SOURCE: 'Data - View asset profile source',
            CTA: 'Evaluate - Click on asset profile CTA',
            VIEW_COMPANY_PROFILE: 'Evaluate - View asset company profile'
        }
    },
    EVALUATION: {
        CREATE: 'Create an evaluation',
        BLOCK_CREATE: 'Create a block',
        BLOCK_EDIT: 'Edit a block',
        BLOCK_DELETE: 'Delete a block',
        COMPLETE: 'Complete an evaluation',
        DELETE: 'Delete an evaluation',
        INVITE: 'Invite to an evaluation',
        REOPENING: 'Reopen an evaluation'
    },
    EVALUATION_COMMENT: {
        CREATE: 'Create an evaluation comment',
        EDIT: 'Edit an evaluation comment',
        DELETE: 'Delete an evaluation comment',
        REPLY: 'Reply to an evaluation comment'
    },
    EVENT_INTEGRATION: {
        CONFERENCE_PAGE_UPDATE: "Click on 'Update' button on Conference page",
        UPDATE_ADMIN_PAGE: "Click on 'Update' button on Administration page",
        CREATE_CONFERENCE: "Click on 'Create Conference'",
        CONFIRM_CONFERENCE_CREATION: "Click on 'Confirm' for conference creation",
        CREATE_LEAD_FROM_MEETING: "Click on 'Create opportunity' from meetings",
        VIEW_MEETING_IN_EVENT: "Click on 'View meeting in Events' on meetings page",
        ACTIVATE_AND_SYNC: "Click on 'Activate+Sync' button on Administration page",
        MEETING_STATUSES: 'Meetings synced split'
    },
    EXPORT_DIALOG: {
        EXPORT_ALL: 'Export - Export all columns',
        EXPORT_VISIBLE: 'Export - Export visible columns',
        OVERVIEW_EXPORT: 'Export - Export option called from overview',
        LIST_EXPORT: 'Export - Export function called from a list',
        TEMPLATE_EXPORT: 'Export - Template selected for the export',
        RETRY: 'Export - Retry function used',
        CANCEL: 'Export - Cancel clicked before generation'
    },
    IMPORT_DIALOG: {
        OPEN: 'Import - Start import process',
        CANCEL: 'Import - Cancel import',
        BROWSE: 'Import - Browse file',
        DRAG_DROP: 'Import - Drag & drop file',
        INSTRUCTIONS: 'Import - See instructions',
        TEMPLATE_DOWNLOAD: 'Import - Download template',
        ANALYSIS: 'Import - File analysis',
        IMPORTED: 'Import - File imported'
    },
    IMPORT_EXCEL: {
        BROWSE_FILE: 'Browse a file',
        CANCEL_IMPORT: 'Cancel import',
        CHOOSE_TEMPLATE: 'Select a template',
        CREATE_LEAD: 'Create imported leads',
        DRAG_N_DROP: "Drag'n'drop a file",
        IMPORT_FILE: 'Click on import leads',
        FILE_ANALYSIS: 'Analyze file',
        SELECT_BRIEF: 'Select a brief to import the leads into',
        VIEW_LEADS: 'View leads'
    },
    INFOGROUPS: {
        DISABLE: 'Infogroups - Disabled',
        ENABLE: 'Infogroups - Enabled'
    },
    KANBAN: {
        KANBAN_VIEW: 'Select kanban view',
        LIST_VIEW: 'Select list view',
        CARD_CLICK: 'Click kanban card',
        ORDER_CHANGED: 'Change kanban order',
        REFRESH: 'Refresh kanban',
        TAB: 'Select kanban tab'
    },
    LIST: {
        SHOW_COLUMN: 'Rich List - Show column',
        HIDE_COLUMN: 'Rich List  - Hide column',
        BOARD_SELECTOR: {
            OPEN_DROPDOWN: 'Rich List  - View selector - Open dropdown',
            SELECT: 'Rich List  - View selector - Select a view',
            CREATE: 'Rich List  - View selector - Create a new view',
            SAVE_AS_NEW: 'Rich List  - Save as new view',
            SHARE: 'Rich List  - Share a view',
            BOOKMARK: 'Rich List  - Bookmark a view',
            REMOVE_BOOKMARK: 'Rich List  - Remove bookmark from a view',
            REMOVE_BOOKMARK_FROM_HOME: 'Home page - Remove bookmark from a view',
            COPY_URL: 'Rich List  - Copy view url',
            RENAME: 'Rich List  - Rename a view',
            UPDATE: 'Rich List  - Save changes of a view',
            DELETE: 'Rich List  - Delete view'
        }
    },
    MEETINGS_IMPORT_KEY: 'Meetings',
    MEETINGS_MANAGEMENT: {
        QUICK_CREATE: 'Create on "Create meeting" from quick create',
        CREATE_FROM_COMPANY: 'Click on "Create meeting" from company page',
        CREATE_FROM_LEAD: 'Click on "Create meeting" from lead page',
        CREATE_FROM_CONTACT: 'Click on "Create meeting" from contact page',
        CREATE_FROM_CONFERENCE: 'Click on "Create meeting" from conference page',
        SAVE_MEETING: 'Click on "Save Meeting" when creating',
        TOGGLE_CONFERENCE: 'Click on "Conference" toggle',
        CREATE_CONFERENCE: 'Create conference',
        EDIT_CONFERENCE: 'Edit conference',
        EDIT_ATTACHMENTS: 'Meeting attachments: Edit',
        TOGGLE_PRIVATE_MEETING: 'Click on "private Meeting" toggle from meeting view page',
        SELECT_RELATED_PROJECTS: 'Selection of "Related Projects"',
        ADD_ATTENDEES: 'Adding attendees on creation page',
        DELETE_MEETING: 'Click on "Delete Meeting"',
        PREVIEW_ATTACH: 'Meeting emails: preview attachment',
        SELECTED_ALL_ATTACHMENTS: "Meeting emails: selected all email's attachments",
        SELECTED_NONE_ATTACHMENTS: "Meeting emails: selected none email's attachments",
        SELECTED_SOME_ATTACHMENTS: "Meeting emails: selected some email's attachments",
        DELETED_EMAIL: 'Meeting emails: delete email',
        NOTES_ADDED: 'Meeting emails: notes added',
        PREVIEW_EMAIL: 'Meeting emails : Preview email',
        UPLOAD: 'Meeting emails: Successfully imported',
        PARSED: 'Meeting emails: Successfully parsed',
        MARK_AS_IMPORTANT: 'Meeting emails: marked as important',
        DELETED_FILE: 'Meeting attachments: delete file',
        DOWNLOAD: 'Meeting attachments : Download file',
        PREVIEW: 'Meeting attachments : Preview file',
        UPLOAD_FILES: 'Meeting Attachments: upload file(s)',
        UPLOAD_EMAILS: 'Meeting Attachments: upload email(s)',
        ADD_NOTES: 'Add notes',
        OPEN_FROM_COMPANY: 'View meeting on company page',
        OPEN_FROM_LEAD: 'View meeting on lead page',
        OPEN_FROM_CONFERENCE: 'View meeting on conference page',
        OPEN_FROM_CONTACT: 'View meeting on contact page',
        OPEN_EDIT_MEETING: 'Click on "Edit meeting"',
        SAVE_MEETING_IN_EDIT: 'Click on "save Meeting" when editing',
        MANAGE_ATTENDEES: 'Click on "Manage Attendees"',
        SAVE_MANAGE_ATTENDEES: 'Click on "Save" after managing attendees',
        TOGGLE_EDIT_PRIVATE_MEETING: 'Click on "Private Meeting" toggle from modification page',
        CONFIRM_PRIVATE_POPUP: 'Confirming private meeting popup'
    },
    MENU_LEFT_BRIEF_CLICK: 'Click on a brief in left hand side menu',
    LEAD_ACCESS_CONTROL: {
        REMOVE_AUTHORIZED_USER: "Remove an user from a lead's ACL"
    },
    LEAD_ATTACHMENTS: {
        DELETE: 'Lead attachments: Delete file',
        DOWNLOAD: 'Lead attachments: Download file',
        EMAIL_DOWNLOAD: 'Lead attachments, emails: Download',
        EMAIL_PAGINATION: 'Lead attachments, emails: Use pagination',
        EDIT: 'Lead attachments: Edit',
        PAGINATION: 'Lead attachments: Use pagination',
        PREVIEW: 'Lead attachments: Preview file',
        UPLOAD: 'Lead attachments: Upload file(s)'
    },
    LEAD_COPY: {
        CANCEL: 'Lead copy: canceled',
        EDIT_NAME: 'Lead copy: edited name',
        EDIT_TAGS: 'Lead copy: edited tags',
        SAVE: 'Lead copy: save'
    },
    LEAD_COMMENTS: {
        ADD: 'Lead comments: Add a new comment',
        DELETE: 'Lead comments: Delete a comment',
        EDIT: 'Lead comments: Edit a comment',
        PAGINATION: 'Lead comments: Use pagination',
        REPLY: 'Lead comments: Add a new comment reply'
    },
    LEAD_CREATION: {
        AUTOFILL_ASSET: 'Asset autopopulate from Directory',
        AUTOFILL_COMPANY: 'Company autopopulate from Directory',
        CREATE_ASSET: 'Create a new asset',
        CREATE_BUTTON: 'Click on Create Lead button',
        CREATE_COMPANY: 'Create a new company',
        SELECT_LINKED_ASSET: 'Select an existing asset linked to data',
        SELECT_LINKED_COMPANY: 'Select an existing company linked to data',
        SELECT_UNLINKED_ASSET: 'Select an existing asset not linked to data',
        SELECT_UNLINKED_COMPANY: 'Select an existing company not linked to data',
        SUCCESSFUL: 'Successfully creating a new lead',
        TYPEAHEAD_ASSET: 'Search asset typeahead',
        TYPEAHEAD_COMPANY: 'Search company typeahead'
    },
    LEAD_DETAILS: {
        OPEN_AGREEMENT: 'Opportunity page - Open agreement',
        CREATE_AGREEMENT: 'Opportunity page - Create agreement',
        OPEN_AGREEMENT_TAB: 'Opportunity page - Open agreement tab',
        CHANGE_AGREEMENT_STATUS: 'Opportunity page - Change status of agreement',
        SEARCH_FOR_AGREEMENT: 'Opportunity page - Search for agreement',
        OPEN_CDA: 'Opportunity page - Open CDA',
        CLOSE_LEAD_PANEL: 'Close lead panel',
        COPY_LEAD: 'Copy lead to another brief',
        COPY_URL: 'Copy lead URL',
        DELETE_LEAD: 'Delete a lead',
        EDIT_ON_HOLD_REMINDER_DATE: 'Edit On-Hold reminder date',
        EXPAND_LEAD_CLICK: 'Display lead in full page',
        MOVE_LEAD: 'Move lead to another brief',
        OPEN_COMPANY_FROM_LEAD: 'Click on a link to a company profile from a lead',
        OPEN_LINKED_COMPANY_RELATED_LEAD: 'Open related lead (linked to a company)',
        REASSIGN_LEAD: 'Reassign lead',
        RENAME_LEAD: 'Rename Lead',
        SELECT_DEAL_TYPE: 'Deal type selected',
        STAGE_CHANGE: 'Workflow stage change',
        STATUS_CHANGE: 'Lead status change',
        UPDATE_COMPANY_PROFILE_FROM_LEAD: 'Update the company from the Company tab in the lead',
        UPDATE_DISCOVERY: 'Edit discovery details',
        UPDATE_GENERAL: 'Edit general',
        UPDATE_LEAD: 'Edit Lead',
        UPDATE_LINKED_COMPANY: 'Update linked company',
        VIEW_LEAD_DETAIL_ACCESS_CONTROL: 'View details about access control flag'
    },
    DOCUMENT_MANAGER: {
        CREATE_FOLDER: 'Document manager - Create a new folder',
        RENAME_FOLDER: 'Document manager - Rename one folder',
        MOVE_FOLDER: 'Document manager - Move one folder',
        DELETE_FOLDER: 'Document manager - Delete one folder',
        MOVE_FILE: 'Document manager - Move one file into folder',
        SEARCH_FOLDER: 'Document manager - Search in folder',
        SEARCH_FLAT: 'Document manager - Search in all documents (flat view)',
        OPEN_FOLDER: 'Document manager - Open a folder',
        NAVIGATE_FOLDER: 'Document manager - Navigate in folder',
        UPLOAD_FILE: 'Document manager - Upload file',
        UPLOAD_EMAIL: 'Document manager - Upload email',
        ANNOTATE: 'Document manager - Annotate document',
        RENAME_DOCUMENT: 'Document manager - Rename document',
        MARK_IMPORTANT: 'Document manager - Mark a document as important',
        UNMARK_IMPORTANT: 'Document manager - Unmark a document as important',
        PROMOTE: 'Document manager - Promote a document',
        DOWNLOAD: 'Document manager - Download a document',
        DELETE_FILE: 'Document manager - Delete a document',
        FLAT_VIEW: 'Document manager - Flat View',
        FOLDER_VIEW: 'Document manager - Folder View',
        SHOW_COLUMN: 'Document manager - Show column',
        HIDE_COLUMN: 'Document manager - Hide column',
        FILTER_OPEN: 'Document manager - Filter Panel - Open',
        FILTER_CLOSE: 'Document manager - Filter Panel - Cancel',
        FILTER_APPLY: 'Document manager - Filter Panel - Apply',
        FILTER_CLEAR: 'Document manager - Filter Panel - Clear',
        FILTER_CLOSE_NO_ACTION: 'Document manager - Filter Panel - Close without actions',
        FILTER_QUICK: 'Document manager - Quick Filters',
        PREVIEW: 'Document Manager - Preview document',
        UNDO_MOVE: 'Document Manager - Undo document or folder move'
    },
    LEAD_FILTERS: {
        APPLY: 'Opportunity List - Filter Panel - Apply',
        CANCEL: 'Opportunity List - Filter Panel - Cancel',
        CLEAR: 'Opportunity List - Clear All Filter',
        OPEN: 'Opportunity List - Filter Panel - Open',
        QUICK_FILTERS: 'Opportunity List - Quick Filters'
    },
    LEAD_LIST: {
        COLUMNS: 'Lead list: Click on Columns menu',
        MORE_FILTERS: 'Lead list: More Filters',
        OPEN_COMPANY: 'Click on company link from lead list',
        REFRESH: 'Lead list: Refresh',
        SORT: 'Lead list: Click on column name to sort leads',
        STATUS_CHANGE: 'Lead list: Lead status change'
    },
    LEAD_LINK_COMPANY: {
        LINK_COMPANY: 'Lead: link company',
        UNLINK_COMPANY: 'Lead: unlink company'
    },
    LEAD_NOTES: {
        CANCEL: 'Lead notes cancel',
        EDIT: 'Lead notes edit',
        SAVE: 'Lead notes save'
    },
    LEAD_PUBLICATION: {
        ADD: 'Lead publication: Add publication',
        AUTOFILL: 'Lead publication: Autofill',
        DELETE: 'Lead publication: Delete publication',
        PAGINATION: 'Lead publication: Use Pagination',
        SHOW_MORE_INFORMATION: 'Lead publication: Click on "Show more information"',
        UPDATE: 'Lead publication: Update publication',
        VIEW: 'Lead publication: View publication'
    },
    LEAD_STATUS_UPDATE: {
        CREATE: 'Status Update - Create',
        DELETE: 'Status Update - Delete',
        UPDATE: 'Status Update - Edit'
    },
    LIST_VALUES: {
        BULK_DELETION: 'Bulk tags/values deletion from the platform settings',
        CREATION: 'New tag/value created from the platform settings',
        MERGE: 'Tags/Values merged from the platform settings',
        SINGLE_DELETION: 'Single tag/Value deletion from the platform settings',
        UPDATE: 'Tag/Value updated from the platform settings'
    },
    MERGE: {
        CONTACT_PAGE: 'Click on Merge button on a contact page',
        COMPANY_PAGE: 'Click on Merge button on a company page',
        COMPANY_CONFIRM: 'Confirm the company merge',
        CONTACT_CONFIRM: 'Confirm the contact merge',
        DUPLICATE_ASSET: 'Error when trying to merge two companies with same asset',
        HELP_CENTER: 'Click on "Help center" on merge rules popin',
        LEARN_MORE: 'Click on "Learn more" of merge popin',
        VIEW: 'Click on “view” button in card of potential duplicate to merge into'
    },
    QUICKSEARCH: {
        SEARCH_DONE: 'Quick search: search done',
        SELECTED_RECENT_COMPANY: 'Quick search: selected recent company',
        SELECTED_RECENT_LEAD: 'Quick search: selected recent lead',
        SELECTED_SEARCHED_COMPANY: 'Quick search: selected searched company',
        SELECTED_SEARCHED_LEAD: 'Quick search: selected searched lead',
        SHOW_RECENT: 'Quick search: show recent list'
    },
    SETTINGS: {
        ADVANCED: 'Click on Advanced',
        AT_A_GLANCE: 'Click on At a Glance',
        CHANGE_OPTION: 'Changing notification option'
    },
    TAG: {
        ADD: 'Add a tag to a lead',
        CREATE: 'Create a new tag',
        REMOVE: 'Remove a tag from a lead',
        UPDATE: 'Update a tag'
    },
    TASK: {
        CREATE: 'Create a new task',
        COMPLETE: 'Complete a task',
        ASSIGN: 'Assign a task',
        REASSIGN: 'Reassign a task',
        REORDER: 'Reorder the task list',
        UPDATE_DUE_DATE: 'Update task due date',
        UPDATE_LABEL: 'Update task label'
    },
    TEMPLATE_LEAD_SUMMARY: {
        CHANGE: 'Change the lead summary template of a brief',
        CREATE: 'Create a new lead summary template',
        DELETE: 'Delete a lead summary template',
        EDIT: 'Edit the lead summary template',
        SELECT: 'Select a lead summary template at brief creation'
    },
    TIMELINE: {
        CLOSE: 'Timeline closed',
        FILTER: 'Timeline filter used',
        NAVIGATION: 'Timeline link used',
        OPEN: 'Timeline button clicked',
        LOADING_MORE: 'Scroll in the timeline triggered additional load'
    },
    AMENDMENTS_NOTES: {
        CANCEL: 'Amendments notes cancel',
        EDIT: 'Amendments notes edit',
        SAVE: 'Amendments notes save'
    },
    AGREEMENT_DETAILS: {
        CHANGE_OWNER: 'Agreement details - Change owner',
        CHANGE_AGREEMENT_STATUS: 'Agreement details - Change status',
        CHANGE_FIELDS_TERRITORIES: 'Agreement details - Change territories',
        CHANGE_DESCRIPTION: 'Agreement details - Description update',
        CHANGE_VALIDITY_DATE: 'Agreement details - Click on edit validity date then confirm?',
        CLICK_ON_MANAGE_ACCESS: 'Agreement details - Click on manage access',
        CONFIRM_EDIT_AGREEMENT: 'Agreement details - Confirm edit agreement',
        CONFIRM_DELETE_AGREEMENT: 'Agreement details - Confirm delete agreement',
        CLICK_ON_AMENDMENT_TAB: 'Agreement details - Click on amendment tab',
        ADD_AN_AMENDMENT: 'Agreement details - Add an amendment',
        OPEN_AN_AMENDMENT: 'Agreement details - Open an amendment',
        CHANGE_AMENDMENT_STATUS: 'Agreement details - Change an amendment’s status',
        CLICK_ON_FILE_IN_AMENDMENT_LIST: 'Agreement details - Click on file in amendment list',
        SEARCH_FOR_AMENDMENT: 'Agreement details - Search for an amendment',
        FILTER_BY_AMENDED_SECTIONS: 'Agreement details - Filter by amended sections',
        MAIN_DOCUMENT_UPDATE: 'Agreement details - Main document update',
        MAIN_DOCUMENT_CLICK: 'Agreement details - Click document update',
        AGREEMENT_EDITION: 'Agreement details - Agreement edition',
        AMENDMENT_SECTION_EDIT: 'Agreement details - Amendment section edit',
        AMENDMENT_EDIT_DOCUMENT: 'Agreement details - Amendment edit document',
        AMENDMENT_DELETE_DOCUMENT: 'Agreement details - Amendment delete document',
        AMENDMENT_EDIT_CLICK: 'Agreement details - Amendment edit click',
        AMENDMENT_DELETE_CLICK: 'Agreement details - Amendment delete click',
        AMENDMENT_DESCRIPTION_UPDATE: 'Agreement details - Amendment description update'
    },
    ALLIANCE_DETAILS: {
        CHANGE_OWNER: 'Alliance details - Change owner',
        CHANGE_ALLIANCE_STATUS: 'Alliance details - Change status',
        CHANGE_FIELDS_TERRITORIES: 'Alliance details - Change territories',
        CHANGE_DESCRIPTION: 'Alliance details - Description update',
        CHANGE_VALIDITY_DATE: 'Alliance details - Click on edit validity date then confirm?',
        CLICK_ON_MANAGE_ACCESS: 'Alliance details - Click on manage access',
        CONFIRM_EDIT_ALLIANCE: 'Alliance details - Confirm edit alliance',
        CONFIRM_DELETE_ALLIANCE: 'Alliance details - Confirm delete alliance',
        ALLIANCE_EDITION: 'Alliance details - Alliance edition'
    },
    ALLIANCE_STATUS_UPDATE: {
        CREATE: 'Status Update - Create',
        DELETE: 'Status Update - Delete',
        UPDATE: 'Status Update - Edit'
    }
};

export const LAYOUT_TYPE = {
    LEAD_DRAWER: 'Lead Drawer',
    LEAD_LIST: 'Lead List',
    LEAD_PAGE: 'Lead Page'
};

export const AMENDMENT_TYPE = {
    AMENDMENT_DRAWER: 'Amendment Drawer'
};
